import './style.css'

import { useMutation, useQuery } from '@apollo/client'
import BreadCrumb from '@medical/components/Breadcrumb'
import EmploymentClassificationIcon from '@medical/components/EmploymentClassificationIcon/EmploymentClassificationIcon'
import { STAFF_CREATE_REPLY_PERMISSION } from '@medical/constant/permissions'
import { checkStaffPermission } from '@medical/libs'
import InquiryScene from '@medical/pages/doctor/Inquiry/InquiryScene'
import { Popover } from 'antd'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { MultiSelect } from 'primereact/multiselect'
import React, { useState } from 'react'

import {
  DOCTORS_CONNECTION,
  UPDATE_CONVERSATION_STATUS,
} from './Inquiries.graphql'

const InquiriesScene = ({
  i18n,
  popup,
  conversations,
  setDataConversation,
  activeStaffs,
  inquirySender,
  doctorId,
  doctorNameFromParams,
  conversationIdFromParams,
  statusSearch,
  setStatusSearch,
  getMoreConversation,
  setNewMsg,
}) => {
  const [
    selectedConversationsDoctorId,
    setSelectedConversationsDoctorId,
  ] = useState(doctorId)
  const [conversationId, setConversationId] = useState(conversationIdFromParams)
  const [fullName, setFullName] = useState('')
  const [doctorName, setDoctorName] = useState(doctorNameFromParams)
  const [conversationStatus, setConversationStatus] = useState('')
  const [assignedStaff, setAssignedStaff] = useState(null)
  const [popOverVisible, setPopOverVisible] = useState(false)
  const [staffUpdateConversationStatus] = useMutation(
    UPDATE_CONVERSATION_STATUS
  )
  const isReplyPermitted = checkStaffPermission({
    functionName: STAFF_CREATE_REPLY_PERMISSION,
  })

  const statusOptions2 = [
    { value: '0', description: '新着' },
    { value: '1', description: '未返信' },
    { value: '2', description: '対応中' },
    { value: '3', description: '対応済' },
  ]

  const variables = {
    first: 10,
    skip: 0,
    where: {
      OR: [
        {
          unSigned_contains: fullName
            ? fullName
                .replace(/ /g, '')
                .replace(/　/g, '')
                .toLowerCase()
            : '',
        },
        {
          email_contains: fullName ? fullName.trim() : '',
        },
      ],
    },
  }

  const { data } = useQuery(DOCTORS_CONNECTION, {
    variables,
    fetchPolicy: 'network-only',
  })

  let listDoctor = <div />
  if (
    data &&
    data.doctorsConnection &&
    data.doctorsConnection.edges.length === 0
  )
    listDoctor = (
      <div>
        <p>{i18n.t('staff.inquiries.noDoctor')}</p>
      </div>
    )
  if (data && data.doctorsConnection && data.doctorsConnection.edges.length > 0)
    listDoctor = (
      <div>
        {data.doctorsConnection.edges.map(value => (
          <div
            key={value.node.id}
            className='list-doctor-item'
            onClick={e => {
              e.stopPropagation()
              setSelectedConversationsDoctorId(value.node.id)
              setDoctorName(`${value.node.lastname} ${value.node.firstname}`)
              setPopOverVisible(false)
              if (value.node.conversation) {
                setConversationId(value.node.conversation.id)
                setConversationStatus(value.node.conversation.status)
                setAssignedStaff(null)
              } else {
                setConversationId('')
                setConversationStatus('')
                setAssignedStaff(null)
              }
              const element = document.getElementById(`${value.node.id}`)
              if (element) element.scrollIntoView()
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <EmploymentClassificationIcon
                workPattern={value.node.workPattern}
              />
              {`${value.node.lastname} ${value.node.firstname} (${value.node.email})`}
            </div>
          </div>
        ))}
      </div>
    )

  const updateConversationStatus = async () => {
    try {
      const result = await staffUpdateConversationStatus({
        variables: {
          conversationId,
          status:
            conversationStatus === 'IN_RESPONSE' ? 'COMPLETED' : 'IN_RESPONSE',
        },
      })
      const newStatus = result.data.staffUpsertConversationStatus.status
      setConversationStatus(newStatus)
      setDataConversation(prev =>
        prev.map(conv =>
          conv.id === conversationId ? { ...conv, status: newStatus } : conv
        )
      )
      popup.success('編集しました。')
    } catch (error) {
      popup.error(error)
    }
  }

  const trackScrolling = e => {
    const scrollHeight = e.target.scrollHeight - e.target.scrollTop
    if (scrollHeight === e.target.clientHeight) {
      getMoreConversation()
    }
  }
  return (
    <React.Fragment>
      <div className='staff-header'>
        <div className='staff-title'>
          {i18n.t('staff.menuBar.inquiries')}
          <BreadCrumb items={[{ title: i18n.t('staff.menuBar.inquiries') }]} />
        </div>
      </div>
      <div className='container is-max'>
        <div className='box row staff-inquiry'>
          <div className='list-conversations'>
            <div className='search-conversations'>
              <div className='row'>
                <InputText
                  style={{ marginRight: '3px' }}
                  className='inquiry-input'
                  placeholder={i18n.t('staff.inquiries.searchDoctor')}
                  value={fullName}
                  onChange={e => setFullName(e.target.value)}
                />
                <Popover
                  placement='bottomRight'
                  content={listDoctor}
                  trigger='click'
                  overlayClassName='drop-doctor'
                  open={popOverVisible}
                >
                  <Button
                    icon='pi pi-search'
                    onClick={() => setPopOverVisible(!popOverVisible)}
                  />
                </Popover>
              </div>
              {/*<Dropdown*/}
              {/*  style={{ width: '100%' }}*/}
              {/*  options={statusOptions}*/}
              {/*  value={statusOptions.find(*/}
              {/*    option => option.value === statusSearch*/}
              {/*  )}*/}
              {/*  optionLabel='description'*/}
              {/*  onChange={e => {*/}
              {/*    setStatusSearch(e.target.value.value)*/}
              {/*  }}*/}
              {/*  // placeholder='ステータス'*/}
              {/*/>*/}
              <MultiSelect
                style={{ width: '100%', marginTop: '3px' }}
                options={statusOptions2}
                value={statusOptions2.filter(option =>
                  statusSearch.includes(option.value)
                )}
                optionLabel='description'
                onChange={e => {
                  setStatusSearch(e.value.map(item => item.value))
                }}
                placeholder='ステータス'
                // fixedPlaceholder
              />
            </div>

            <div
              className='conversations-box'
              // ref={chatBoxRef}
              id='listConversationScroll'
              onScroll={trackScrolling}
            >
              {conversations &&
                conversations.length > 0 &&
                conversations.map(value =>
                  value.isReadByStaff ? (
                    <div
                      key={value.id}
                      id={value.doctor.id}
                      className={
                        value.doctor.id === selectedConversationsDoctorId
                          ? 'conversation selected'
                          : 'conversation'
                      }
                      onClick={() => {
                        setPopOverVisible(false)
                        if (value.doctor.id !== selectedConversationsDoctorId) {
                          setSelectedConversationsDoctorId(value.doctor.id)
                          setConversationId(value.id)
                          setConversationStatus(value.status)
                          setAssignedStaff(value.assignedStaff || null)
                        } else {
                          setSelectedConversationsDoctorId('')
                          setDoctorName('')
                          setConversationId('')
                          setConversationStatus('')
                          setAssignedStaff(null)
                        }
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                        <div style={{ flexShrink: 0, marginRight: '4px' }}>
                          <EmploymentClassificationIcon
                            workPattern={value.doctor.workPattern}
                          />
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: '14px' }}>
                            {`${value.doctor.lastname} ${value.doctor.firstname}`}
                          </div>
                          <div className='email' style={{ margin: 0, wordBreak: 'break-all' }}>{`(${value.doctor.email})`}</div>
                          <div style={{ display: 'flex', gap: '3px', marginTop: '4px' }}>
                            {
                              value.status === 'IN_RESPONSE' && <span
                                style={{ background: '#ff4d4f', color: '#fff', padding: '1px 6px', borderRadius: '8px', fontSize: '13px', fontWeight: 'bold', lineHeight: '16px' }}>
                                対応中</span>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      key={value.id}
                      id={value.doctor.id}
                      className={
                        value.doctor.id === selectedConversationsDoctorId
                          ? 'conversation selected'
                          : 'conversation'
                      }
                      onClick={() => {
                        setPopOverVisible(false)
                        if (value.doctor.id !== selectedConversationsDoctorId) {
                          setSelectedConversationsDoctorId(value.doctor.id)
                          setConversationId(value.id)
                          setConversationStatus(value.status)
                          setAssignedStaff(value.assignedStaff || null)
                        } else {
                          setSelectedConversationsDoctorId('')
                          setDoctorName('')
                          setConversationId('')
                          setConversationStatus('')
                          setAssignedStaff(null)
                        }
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                        <div style={{ flexShrink: 0, marginRight: '4px' }}>
                          <EmploymentClassificationIcon
                            workPattern={value.doctor.workPattern}
                          />
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: '14px' }}>
                            {`${value.doctor.lastname} ${value.doctor.firstname}`}
                          </div>
                          <div className='email' style={{ margin: 0, wordBreak: 'break-all' }}>{`(${value.doctor.email})`}</div>
                          <div style={{ display: 'flex', gap: '3px', marginTop: '4px' }}>
                            {
                              value.status === 'NEW' && <span
                                style={{ background: '#f03a6c', color: '#fff', padding: '1px 6px', borderRadius: '8px', fontSize: '13px', fontWeight: 'bold', lineHeight: '16px' }}>
                                New</span>
                            }
                            <span
                              style={{ background: '#52c41a', color: '#fff', padding: '1px 6px', borderRadius: '8px', fontSize: '13px', fontWeight: 'bold', lineHeight: '16px' }}>
                              未返信</span>
                            {
                              value.status === 'IN_RESPONSE' && <span
                                style={{ background: '#ff4d4f', color: '#fff', padding: '1px 6px', borderRadius: '8px', fontSize: '13px', fontWeight: 'bold', lineHeight: '16px' }}>
                                対応中</span>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                )}
            </div>
          </div>
          <InquiryScene
            i18n={i18n}
            setNewMsg={setNewMsg}
            doctorId={selectedConversationsDoctorId}
            conversationStatus={conversationStatus}
            conversationId={conversationId}
            inquirySender={inquirySender}
            doctorName={doctorName}
            isReplyPermitted={isReplyPermitted}
            activeStaffs={activeStaffs}
            assignedStaff={assignedStaff}
            setConversationId={e => {
              setConversationId(e)
            }}
            setDoctorName={e => {
              setDoctorName(e)
            }}
            updateConversationStatus={updateConversationStatus}
          />
        </div>
      </div>
    </React.Fragment>
  )
}
export default InquiriesScene
